import { useCallback, useEffect, useState } from 'react';

export function useRegisterSW() {
	const [waitingWorker, setWaitingWorker] = useState<ServiceWorker | null>(
		null,
	);

	useEffect(() => {
		if (!('serviceWorker' in navigator)) return;

		navigator.serviceWorker.register('/sw.js').then(registration => {
			if (registration.waiting) {
				setWaitingWorker(registration.waiting);
			}

			registration.addEventListener('updatefound', () => {
				const newWorker = registration.installing;
				if (!newWorker) return;

				if (
					newWorker.state === 'installed' &&
					navigator.serviceWorker.controller
				) {
					setWaitingWorker(newWorker);
					return;
				}

				newWorker.addEventListener('statechange', () => {
					if (
						newWorker.state === 'installed' &&
						navigator.serviceWorker.controller
					) {
						setWaitingWorker(newWorker);
					}
				});
			});

			// alle 5 Minuten nach Updates suchen, solange der Service Worker aktiv ist
			const interval = setInterval(() => {
				registration.update().catch(() => {});
			}, 5 * 60 * 1000);

			return () => clearInterval(interval);
		});

		navigator.serviceWorker.addEventListener('controllerchange', () => {
			window.location.reload();
		});
	}, []);

	const updateApp = useCallback(() => {
		if (!waitingWorker) return;
		waitingWorker.postMessage({ type: 'SKIP_WAITING' });
		setWaitingWorker(null);
	}, [waitingWorker]);

	return { needsUpdate: !!waitingWorker, updateApp };
}
